import { Grid } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';
import { SectionProps } from '../../utils/SectionProps';
import FooterNav from '../layout/partials/FooterNav';

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

const Hero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {

  const outerClasses = classNames(
    'hero section center-content',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'hero-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container-sm">
        <div className={innerClasses}>
          <div className="hero-content">
            <Grid container spacing={1} style={{ textAlign: "center" }}>
              <Grid item md={12} sm={12}>
                <h3 className="mt-0 mb-16 reveal-from-bottom" data-reveal-delay="200">  Como entrar em contato com a<span className="text-color-success"> Ruralhub</span> em caso de dúvidas</h3>
                <p className="text-white mb-3">
                  Saiba mais sobre como a privacidade funciona em nosso aplicativo.
                  <br />Se você tem dúvidas sobre esta Política ou perguntas, queixas ou solicitações relacionadas às suas informações, entre em contato conosco conforme descrito
                </p>
                <p>Entre em contato pelos links abaixo:</p>
              </Grid>

              <Grid item md={12} sm={12}>
                <FooterNav />
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </section>
  );
}

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;